import {createContext} from "react";

export default createContext({getUser:()=>{}, setUser: (user) => {}})